import React from "react";
import { Box } from "@mui/material";
import AdminDashboard from "../../Admin/Dashboard/Dashboard";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UserPropertiesTable from "./UserPropertiestable";

const DisplayUserProperties = () => {
  return (
    <>
      <AdminDashboard />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f5f5f5",
          px: { xs: 2, md: 4 },
          py: { xs: 2, md: 4 },
          gap: 4,
        }}
      >
        <UserPropertiesTable />
        <ToastContainer position="top-right" autoClose={2000} />
      </Box>
    </>
  );
};

export default DisplayUserProperties;